//英文 (美国)
export default {
  inputPlaceholder: 'Please input',
  selectPlaceholder: 'Please select',
  checkAll:"Select all",
  save:"Save"
}